import { TCommonProps } from "./common";
import {
    aecom,
    centrica,
    markinson,
    myp,
    qut,
    technologyone,
} from "../assets";

export type TExperience = {
    companyName: string;
    iconBg: string;
    date: string;
    points: string[];
} & Required<Omit<TCommonProps, "name">>;

export const experiences: TExperience[] = [
    {
        title: "Senior Developer",
        companyName: "Centrica",
        icon: centrica,
        iconBg: "#F7EEED",
        date: "Early 2025 - Mid 2025",
        points: [
            "Architected cross-domain serverless integrations using shared platform microservices, enabling event-driven workflows among 8+ business units. Technologies included TypeScript, Node, OAuth, sFTP, AWS Transfer Family and Azure service such as Logic Apps, Function Apps and Blob storage",
            "Extended Azure API Management capabilities by introducing Workspaces to enable domain-aligned API governance and environment isolation across 6+ product teams",
            "Prototyped a customer-facing AI chatbot Ask Bill powered by Amazon Bedrock Agents, Claude Sonnet LLM and RAG to reduce billing-related support effort through automated query resolution",
            "Drove engineering quality initiatives across 3 squads totalling 12+ developers by formalising coding best practices, code review guidelines, new starter guides and technical interview exercises",
            "Managed DevSecOps and GitOps processes by building and maintaining cloud infrastructure using IaC with Terraform and AI-assisted GitHub Copilot. Infrastructure included alarms, metrics, API policies, CI/CD pipelines and asynchronous platforms"
        ],
    },
    {
        title: "Senior Developer | Assoc. Architect",
        companyName: "TechnologyOne",
        icon: technologyone,
        iconBg: "#F7EEED",
        date: "Late 2017 - Mid 2023",
        points: [
            "Co-developed a greenfield hybrid web application for use by 200k+ Higher Education students to support their course and study management. Technologies included C#, TypeScript, React and Redux and served using AWS DynamoDB, S3 and Lambda to deliver a robust, scalable and highly available cloud solution",
            "Architected major enhancements to the Debtor Management functionality of the flagship Property and Rating product to support bulk and partial transaction adjustments to improve operational efficiency for 100+ councils, involving 6 months of development work",
            "Optimised data migration processes to handle 100+ million transactions, where bottlenecks had become a dealbreaker for some clients, by reducing migration runtime by 98% from 50+ hours down to 1 hour; the client and senior leadership team were thrilled with such an impressive turnaround",
            "Led a major GitLab workflow improvement project across 3 product teams, to take advantage of BitBucket cascade merging to streamline the development process for 12+ developers",
            "Led the design for integrating Request Management and Student Management in-house products, to enable students to lodge cases and support Payment Gateway integration",
            "Managed the team’s CI/CD build channels in TeamCity, code reviews/merging, patching back to prior releases, hotfixes and production data scripting",
            "Showcased new features during sprint review and engaging with the consulting/customer teams",
        ],
    },
    {
        title: "Web Application Developer",
        companyName: "MYP Corporation",
        icon: myp,
        iconBg: "#F7EEED",
        date: "Mid 2016 - Mid 2017",
        points: [
            "Worked closely with the client CEO of an insurance company, and the CEO of MYP to deliver a $100k+ project by enhancing in-house software to build out the workflow for generating insurance policies, and developing a management dashboard, supporting various user roles, for staff, brokers and underwriters. Technologies included React, Redux, C#, MVC and SQL Server",
            "Completed all outstanding development work that was preventing MYP’s in-house WYSIWYG builder formSPACE from being released, delivering a superior UX focused on empowering users",
            "Scheduled release engineer to deploy all company updates to their web application",
            "Won the WOW award for exceptional performance and continually exceeding client expectations",
        ],
    },
    {
        title: "ERP Software Developer | Consultant",
        companyName: "Markinson Business Solutions",
        icon: markinson,
        iconBg: "#F7EEED",
        date: "Mid 2010 - Mid 2016",
        points: [
            "Co-developed a Windows Mobile native offline application used by 20+ large wholesalers for stocktaking, picking and packing of thousands of goods, and other warehouse functions such as stock enquiry and bin assignment. Technologies included Resco UI controls for the frontend, SQLite for local storage and C# web services for ERP API integration",
            "Architected a high-performant document automation workflow from the ERP software using the Bottomline Transform Suite, capable of transmitting 50+ business documents per second",
            "Worked solely with a major client during a go-live weekend to deliver various ETL tasks for a significant merger of client businesses; the client was very impressed with the successful outcome, and my ability to accommodate their needs",
            "Worked with 20+ client organisations on a number of ERP integration projects including: B2BE EDI, SimPro, SAP OCI, ZAP BI, QlikView, Infor CRM, Joomla, IFS SmartFreight, StarTrack Express, Barcode/Despatch printing, PayPal, Statement run transmission and Banking auto-payments",
            "Top fee earner in the division consistently maintaining a billing utilisation rate of at least 80%",
            "Trained and mentored a total of 8 graduate developers to build-up a successful and motivated team",
            "Won the Positive Partnership award for being an ultimate team player, versatile and adaptable",
            "Won the Inspiring Individual award for delivering high quality even under immense time pressure",
        ],
    },
    {
        title: "Assistant Financial Accountant",
        companyName: "AECOM",
        icon: aecom,
        iconBg: "#F7EEED",
        date: "Mid 2008 - Mid 2010",
        points: [
            "Bookkeeping in the General, Purchases and Sales ledgers",
            "Preparation of monthly financial statements and analysis of reporting figures",
            "Maintenance of the Fixed Asset Register, Debtor's Aging and Cash flow forecast",
            "Bank and credit card reconciliation, and domestic and international payments",
        ],
    },
    {
        title: "B.Bus | B.IT",
        companyName: "Queensland University of Technology",
        icon: qut,
        iconBg: "#99FAFF",
        date: "2006 - 2009",
        points: [
            "Graduated with a distinction in IT",
            "Accounting and Database Design majors",
            "Multi-core CPU's and Parallel programming capstone project",
            "Academic transcript can be provided on request",
        ],
    },
];
